var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMapsIcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 2.66634C1.33398 2.31272 1.47446 1.97358 1.72451 1.72353C1.97456 1.47348 2.3137 1.33301 2.66732 1.33301H13.334C13.6876 1.33301 14.0267 1.47348 14.2768 1.72353C14.5268 1.97358 14.6673 2.31272 14.6673 2.66634V13.333C14.6673 13.6866 14.5268 14.0258 14.2768 14.2758C14.0267 14.5259 13.6876 14.6663 13.334 14.6663H2.66732C2.3137 14.6663 1.97456 14.5259 1.72451 14.2758C1.47446 14.0258 1.33398 13.6866 1.33398 13.333V2.66634ZM2.66732 9.13301V6.26634H5.33398V9.13301H2.66732ZM2.66732 10.4663V13.333H5.33398V10.4663H2.66732ZM6.66732 10.4663V13.333H13.334V10.4663H6.66732ZM13.334 9.13301V6.26634H6.66732V9.13301H13.334ZM6.66732 4.93301H13.334V2.66634H6.66732V4.93301ZM5.33398 2.66634H2.66732V4.93301H5.33398V2.66634Z",
    fill: "#7E716D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMapsIcom);
export default __webpack_public_path__ + "static/media/menu-maps-icom.ea91a4f75b41929725b8c609e339fb5f.svg";
export { ForwardRef as ReactComponent };